import "../css"
import "./fontawesome"

import Autocomplete from "bootstrap5-autocomplete"
import { Stimulus, Controller } from "./stimulus"

Stimulus.register("autocomplete", class extends Controller {
  connect() {
    new Autocomplete(this.element, {
      fullwidth: true,
      suggestionsThreshold: 0
    })
  }
})

addEventListener("turbo:before-cache", () => {
  document.querySelectorAll("[data-controller='autocomplete']").forEach(el => {
    Autocomplete.getInstance(el)?.dispose()
  })
})
